import { Heading } from '@ui/primitives/Heading'
import { Text } from '@ui/primitives/Text'
import { Icon } from '@ui/primitives/Icon'
import { useTranslation } from '@/lib'

export function TablatureHelp() {
  const { t } = useTranslation()

  const helpSections = [
    {
      title: t('tablatures.help.basics'),
      items: [
        { symbol: 'S', description: t('tablatures.notation.short_blow') },
        { symbol: 'A', description: t('tablatures.notation.short_draw') },
        { symbol: '1', description: t('tablatures.notation.note') },
        { symbol: '1..', description: t('tablatures.notation.long_note') },
      ],
    },
    {
      title: t('tablatures.help.alterations'),
      items: [
        { symbol: "1'", description: t('tablatures.notation.alteration_12') },
        { symbol: "1''", description: t('tablatures.notation.alteration_1') },
        { symbol: "1'''", description: t('tablatures.notation.alteration_112') },
        { symbol: '1o', description: t('tablatures.notation.overblow') },
      ],
    },
    {
      title: t('tablatures.notation.format'),
      items: [
        { symbol: '|', description: t('tablatures.notation.divider') },
        { symbol: ' ', description: t('tablatures.notation.space') },
        { symbol: '|:', description: t('tablatures.notation.repeat_start') },
        { symbol: ':|', description: t('tablatures.notation.repeat_end') },
        { symbol: '/', description: t('tablatures.notation.break') },
        { symbol: '(', description: t('tablatures.notation.group_start') },
        { symbol: ')', description: t('tablatures.notation.group_end') },
      ],
    },
  ]

  return (
    <div className="space-y-6">
      {helpSections.map((section, sectionIndex) => (
        <section key={sectionIndex}>
          <Heading 
            as="h3" 
            size="md" 
            className="mb-4 flex items-center gap-2"
          >
            <Icon name="help" size="sm" />
            {section.title}
          </Heading>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {section.items.map((item, itemIndex) => (
              <div key={itemIndex} className="flex items-center gap-3">
                <span className="inline-flex items-center justify-center w-10 h-8 bg-white text-grey-700 text-sm font-mono font-bold rounded border-1 border-grey-700 flex-shrink-0 text-center">
                  {item.symbol === ' ' ? '\u00A0' : item.symbol}
                </span>
                <Text size="sm">
                  {item.description}
                </Text>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}
